import { DeleteOutline as DeleteOutlinedIcon } from '@mui/icons-material';
import { Alert, Box } from '@mui/material';
import React from 'react';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { IAssemblyComponent } from 'src/interfaces';
import { lang } from 'src/utils';
import { FileTypes, getFileExtensionType } from 'src/utils/file-types';

import { BackupComponentInterface } from './BackupComponent.interface';
import {
  BackupComponentButton,
  BackupComponentContainer,
  BackupComponentItem,
  BackupComponentName,
  IconWrapper,
  OpenWithIconStyled,
  StyledDivider,
} from './BackupComponent.styled';

export const BackupComponent = (props: BackupComponentInterface) => {
  const handleDeleteBackup = (
    deletedAssemblyComponent: Partial<IAssemblyComponent>,
  ) => {
    props.onDeletedBackupAssemblyComponent(
      deletedAssemblyComponent as IAssemblyComponent,
    );
  };

  const handleButtonMouseDown = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.stopPropagation();
  };

  const backupComponentType = getFileExtensionType(
    props.backupComponent?.component?.config?.background,
  );

  const editable = props.editable ?? true;

  return (
    <BackupComponentContainer>
      <BackupComponentItem>
        <BackupComponentName>
          <CustomTooltip
            width={500}
            placement="right"
            title={props.backupComponent.component?.name}
            overflowLineNumber={1}>
            <BackupComponentButton
              variant="text"
              onClick={() =>
                props.onBackComponentSelection(
                  props.backupComponent as IAssemblyComponent,
                )
              }
              onMouseDown={handleButtonMouseDown} // Prevent drag and drop when the button is clicked
            >
              {props.backupComponent.component?.name}
            </BackupComponentButton>
          </CustomTooltip>
        </BackupComponentName>

        {backupComponentType === FileTypes.VIDEO && (
          <Box flexShrink={0} display={'flex'} alignItems={'center'}>
            <DynamicTooltipChip
              chipName={`${(
                (props.backupComponent?.config?.duration || 0) / 1000
              )
                .toFixed(1)
                .replace(/[.,]0$/, '')}s`}
            />
          </Box>
        )}

        {editable && (
          <Box flexShrink={0} display={'flex'} alignItems={'center'}>
            <IconWrapper size="medium">
              <OpenWithIconStyled />
            </IconWrapper>
            <IconWrapper
              size="medium"
              onClick={() => handleDeleteBackup(props.backupComponent)}>
              <DeleteOutlinedIcon data-testid="DeleteOutlineIcon" />
            </IconWrapper>
          </Box>
        )}
      </BackupComponentItem>
      {props.showSoftSellInfo &&
        (props.backupComponent.component?.start_date ||
          props.backupComponent.component?.end_date) && (
          <Alert severity="info">
            {lang.softSellInfo.dateDescription(
              props?.backupComponent?.component?.start_date,
              props?.backupComponent?.component?.end_date,
            )}
          </Alert>
        )}
      <StyledDivider />
    </BackupComponentContainer>
  );
};
